import React from "react";
import { connect } from "react-redux";
import { Link,useNavigate } from "react-router-dom";
import Blomboss from "../../assets/images/BlombosLogo.svg";

const Page404 = (props) => {
  const navigate = useNavigate();

  return (
    <div className="theme-cyan">
      <div>
        <div className="vertical-align-wrap">
          <div className="vertical-align-middle auth-main">
            <div className="auth-box">
              <div className="top">
                <img src={Blomboss} alt="Blomboss" />
              </div>
              <div className="card">
                <div className="header">
                  <h3>
                    <span className="clearfix title">
                      <span className="number left">404</span>
                      <span className="text">
                        Oops! <br />
                        Page Not Found
                      </span>
                    </span>
                  </h3>
                </div>
                <div className="body">
                  <p>
                    The page you were looking for could not be found, please{" "}
                    <Link to="#">contact us</Link> to report this issue.
                  </p>
                  <div className="margin-top-30">
                    <button
                      className="btn btn-default"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-arrow-left"></i>&nbsp;
                      <span>Go Back</span>
                    </button>
                    &nbsp;
                    <a className="btn btn-primary" href="/">
                      <i className="fa fa-home"></i>&nbsp;<span>Home</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(Page404);